module.exports = __webpack_public_path__ + "img/polygon.62944c9c.svg";